
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/errors/404",
      function () {
        return require("private-next-pages/errors/404.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/errors/404"])
      });
    }
  